import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../api";

export const fetchUser = createAsyncThunk("user/details", async () => {
  const response = await axiosInstance.get(`/rest/user/details`);
  return response.data;
});

export const logoutUser = createAsyncThunk("user/logout", async () => {
  const response = await axiosInstance.post(`/rest/user/logout`);
  return response.data;
});

export const getCorpList = createAsyncThunk("user/corpList", async () => {
  const response = await axiosInstance.get(`/rest/user/corpList`);
  return response.data;
});

export const changeCorp = createAsyncThunk(
  "user/corp/change",
  async (payload: any) => {
    let response = await axiosInstance.post(`/rest/user/changeCorp`, payload);
    return response.data;
  },
);

interface User {
  features: string[];
  firstName: string;
  lastName: string;
  corpList: UserCorp[];
  corp: UserCorp;
  name: string;
}

interface UserCorp {
  corpCode: string;
  corpName: string;
  productName: string;
  productId: number;
}

interface UserState {
  user: User;
  loading?: boolean;
  loaded?: boolean;
  error?: string | null;
}

// Initial state
const initialState: UserState = {
  user: {
    firstName: "",
    lastName: "",
    corpList: [],
    corp: { corpCode: "", corpName: "", productName: "", productId: 0 },
    name: "",
    features: [],
  },
  loading: false,
  loaded: false,
  error: null,
};

export const extractProducts = (user: User) => {
  const products = new Set();
  user.corpList.forEach((corp) => {
    products.add(corp.productName);
  });
  return Array.from(products);
};

const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchUser.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchUser.fulfilled, (state, action) => {
        state.loading = false;
        state.loaded = true;
        state.user = action.payload;
      })
      .addCase(fetchUser.rejected, (state, action) => {
        state.loading = false;
        state.loaded = true;
        state.error = action.error.message || null;
      });
  },
});

export const getUser = (state: { user: User }) => state.user;

export default userSlice.reducer;
